import { NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LoaderTesteComponent } from '../../../loader/loader-teste/loader-teste.component';
import { NotificationEntity } from '../../../services/notification/notification.model';
import { NotificationService } from '../../../services/notification/notification.service';
import { SidebarComponent } from '../../../sidebar/sidebar.component';
import { ToastService } from '../../../toast/toast.service';

@Component({
  standalone: true,
  selector: 'side-notification',
  templateUrl: './side-notification.component.html',
  styleUrls: ['./side-notification.component.scss'],
  imports: [SidebarComponent, NgTemplateOutlet, LoaderTesteComponent],
})
export class SideNotification implements OnInit {
  notifications: NotificationEntity[] = [];

  loadingNotifications: boolean = true;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.retrieveNotification();
  }

  markAsRead(notification: NotificationEntity): void {
    this.notificationService.markAsRead(notification?.documentId).subscribe({
      next: () => {
        this.notifications.forEach((notificationItem) => {
          if (notificationItem?.id === notification?.id) {
            notificationItem.statuses = 'received';
          }
          return notificationItem;
        });
        this.retrieveNotification();
      },
      error: (err) => {
        this.toastService.error(
          `Não foi possível marcar como lida: ${err.error.error.message}`,
        );
      },
    });

    this.syncCounterNotifications();
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead().subscribe({
      next: () => {
        this.notifications.forEach(
          (notification) => (notification.statuses = 'received'),
        );
        this.syncCounterNotifications();
        this.retrieveNotification();
      },
      error: (err) => {
        this.toastService.error(
          `Não foi possível marcar todas como lida: ${err.error.error.message}`,
        );
      },
    });
  }

  private retrieveNotification(): void {
    this.notificationService.listNotificationsPaged().subscribe({
      next: ({ meta, data }) => {
        this.notifications = data;
        this.syncCounterNotifications();
      },
      error: (err) => {
        this.toastService.warning(
          `Não foi possível recuperar notificações: ${err.error.error.message}`,
        );
      },
      complete: () => {
        this.loadingNotifications = false;
      },
    });
  }

  private syncCounterNotifications(): void {
    const counterUnread: number = this.notifications.filter(
      (notification) => notification.statuses !== 'received',
    ).length;

    this.notificationService.updateUnreadCount(counterUnread);
  }
}
